export const routes = {
  home: '/',
  pantry: '/pantry',
  shoppingList: '/shopping-list',
  login: '/login',
  register: '/register',
};
